import { ReactNode } from 'react';

import { TableCell, TableCellProps, TableSortLabel } from '@mui/material';

import { SortDirection } from '../../types/subscription';

interface SortableHeaderCellProps<S extends string> extends Omit<TableCellProps, 'children'> {
  column: S;
  sort: S;
  direction: SortDirection;
  /** Called with the column; the page flips the direction when it is already the sorted column. */
  onSort: (column: S) => void;
  children: ReactNode;
}

/** Table header cell that sorts the (server-side) list by `column` when clicked. */
export const SortableHeaderCell = <S extends string>({
  column,
  sort,
  direction,
  onSort,
  children,
  ...cellProps
}: SortableHeaderCellProps<S>) => {
  const active = sort === column;
  return (
    <TableCell {...cellProps} sortDirection={active ? (direction === 'ASC' ? 'asc' : 'desc') : false}>
      <TableSortLabel
        active={active}
        direction={active && direction === 'ASC' ? 'asc' : 'desc'}
        onClick={() => onSort(column)}
        sx={{
          whiteSpace: 'nowrap',
          '&.Mui-active': { color: '#B3EC49' },
          '&.Mui-active .MuiTableSortLabel-icon': { color: '#B3EC49' },
        }}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );
};
